var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFileCertificate = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0834 1.58325H5.54171C5.12178 1.58325 4.71905 1.75007 4.42212 2.047C4.12519 2.34393 3.95837 2.74666 3.95837 3.16659V14.2499C3.95837 14.6698 4.12519 15.0726 4.42212 15.3695C4.71905 15.6664 5.12178 15.8333 5.54171 15.8333H7.91671V18.2083L9.50004 17.4166L11.0834 18.2083V15.8333H13.4584C13.8783 15.8333 14.281 15.6664 14.578 15.3695C14.8749 15.0726 15.0417 14.6698 15.0417 14.2499V5.54159M11.0834 11.8749V13.4583L9.50004 12.6666L7.91671 13.4583V11.8749L6.33337 11.0833L7.91671 10.2916V8.70825L9.50004 9.49992L11.0834 8.70825V10.2916L12.6667 11.0833M10.2917 6.33325V2.77075L13.8542 6.33325H10.2917Z",
    fill: "#5D5CF5"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFileCertificate, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/file-certificate.1a4a5fb4.svg";
export { ForwardRef as ReactComponent };